import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DOMPurify from 'dompurify';
import { extractSelectedTicketFromState } from 'extractFromState';
import { showNudgePopup } from '../../actions';
import { setAnchorElementsTarget } from '../../util';
import { OUTBOUND } from '../../constants/messageDirection';
import { SenderInDisplayComponent } from 'components/Widgets/SenderInDisplayComponent/SenderInDisplayComponent';
import { getMessageAvatar } from 'util/avatarUtil';
import {
  HtmlEditor,
  PlainTextEditor,
  StyledNudge,
  StyledMessageComponent,
  HeaderDiv,
  TitleH3,
  CloseButton,
  ExpertName,
  MessageHeaderDiv,
  TextSpan,
  RemoveButton,
  ConversationHeadingDiv,
  SubTitleH4,
  ToggleButton,
  FlexRowDiv,
} from './Nudge.styles';

const Nudge = ({ conversation, closeNudgeWindow, displayNudgePopup, selectedTicket }) => {
  const { allMessages, ...messages } = conversation;
  const [messagesIds, setMessagesIds] = useState(allMessages);
  const [hideNotes, setHideNotes] = useState(false);
  const [hiddenNamesIds, setHiddenNamesIds] = useState([]);

  useEffect(() => {
    setMessagesIds(allMessages);

    return () => {
      setHideNotes(false);
      setMessagesIds([]);
      setHiddenNamesIds([]);
    };
  }, [allMessages, displayNudgePopup]);

  const toggleHideNotes = (hide) => setHideNotes(hide);

  const removeMessage = (messageId) => {
    const filtered = messagesIds.filter((id) => id !== messageId);
    setMessagesIds(filtered);
  };

  const hideName = (messageId) =>
    hiddenNamesIds.includes(messageId)
      ? setHiddenNamesIds(hiddenNamesIds.filter((id) => id !== messageId))
      : setHiddenNamesIds([...hiddenNamesIds, messageId]);

  const getDate = (ISOTime) => moment(ISOTime).format('MM/DD/YY');
  const getTime = (ISOTime) => moment(ISOTime).format('h:mm a');

  return (
    displayNudgePopup && (
      <StyledNudge>
        <div className="NudgeMessagesHistory">
          <HeaderDiv>
            <TitleH3>Nudge Editor</TitleH3>
            <FlexRowDiv>
              <FlexRowDiv>
                <TextSpan bold gray block>
                  Hide Notes
                </TextSpan>
                <ToggleButton checked={hideNotes} onClick={() => toggleHideNotes(!hideNotes)} />
              </FlexRowDiv>
              <CloseButton autoFocus onClick={() => closeNudgeWindow()} />
            </FlexRowDiv>
          </HeaderDiv>
          <ConversationHeadingDiv>
            <div>
              <SubTitleH4>
                <TextSpan bold>{selectedTicket.subject && selectedTicket.subject}</TextSpan>
                <TextSpan>{selectedTicket.createdAt && getDate(selectedTicket.createdAt)}</TextSpan>
                <TextSpan>{selectedTicket.createdAt && getTime(selectedTicket.createdAt)}</TextSpan>
              </SubTitleH4>
            </div>
            <SubTitleH4>{selectedTicket.smbName && selectedTicket.smbName}</SubTitleH4>
          </ConversationHeadingDiv>
          <div>
            {messagesIds.length > 0 &&
              messagesIds.map((messageId) => {
                const message = messages[messageId];
                const messageDate = message.createdAt && getDate(message.createdAt);
                const messageTime = message.createdAt && getTime(message.createdAt);
                const avatar = selectedTicket && getMessageAvatar(message, selectedTicket.ticketId);

                let messageContent = message.messageBodyHtml ? message.messageBodyHtml : message.messageBody;
                messageContent = DOMPurify.sanitize(messageContent);
                messageContent =
                  message.direction === OUTBOUND ? setAnchorElementsTarget(messageContent) : messageContent;

                return (
                  <StyledMessageComponent
                    key={messageId}
                    direction={message && message.direction}
                    hideNotes={hideNotes}
                    avatar={avatar}
                  >
                    <MessageHeaderDiv>
                      <ExpertName
                        role="button"
                        onClick={() => hideName(messageId)}
                        hiddenName={hiddenNamesIds.includes(messageId)}
                      >
                        <SenderInDisplayComponent isAdmin={false} message={message} />
                      </ExpertName>
                      <TextSpan>
                        {messageDate} {messageTime}
                      </TextSpan>
                      <RemoveButton onClick={() => removeMessage(messageId)}>Remove</RemoveButton>
                    </MessageHeaderDiv>
                    {message.messageBodyHtml ? (
                      <HtmlEditor contentEditable dangerouslySetInnerHTML={{ __html: messageContent }} />
                    ) : (
                      <PlainTextEditor contentEditable dangerouslySetInnerHTML={{ __html: messageContent }} />
                    )}
                  </StyledMessageComponent>
                );
              })}
          </div>
        </div>
      </StyledNudge>
    )
  );
};

const mapStateToProps = (state) => ({
  conversation: state.conversation,
  displayNudgePopup: state.ui.popups.displayNudgePopup,
  selectedTicket: extractSelectedTicketFromState(state),
});

const mapDispatchToProps = (dispatch) => ({
  closeNudgeWindow: () => dispatch(showNudgePopup(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Nudge);
